import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import{ ModalModule } from '../../../../../common/component/modal/modal.module';

import { AddEditUserComponent } from './add-edit-user.component';
import { UsersStateService } from './users-state.service';
import { SpinnerModule } from '../../../../../common/component/spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,DropDownsModule
    ,ModalModule
    ,SpinnerModule
  ],
  declarations: [AddEditUserComponent],
  exports: [AddEditUserComponent],
  providers: [UsersStateService],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AddEditUserModule { }
